export default __webpack_public_path__ + "static/media/diagnosis.cc5a67b6.svg";